function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { CONNOTATIONS } from "@neru/types";
import { Snackbar } from "@neru/ui";
import { useSelector } from "react-redux";
import { useNotifications } from "../../hooks";
var useAppSelector = useSelector;
var _obj;
var icons = (_obj = {}, _define_property(_obj, CONNOTATIONS.announcement, "megaphone-solid"), _define_property(_obj, CONNOTATIONS.success, "check-circle-solid"), _define_property(_obj, CONNOTATIONS.alert, "error-solid"), _define_property(_obj, CONNOTATIONS.primary, "message-solid"), _define_property(_obj, CONNOTATIONS.info, "info-solid"), _define_property(_obj, CONNOTATIONS.cta, "sparkles-solid"), _define_property(_obj, CONNOTATIONS.warning, "warning-solid"), _obj);
export var NotificationsTicker = function() {
    var dismissNotification = useNotifications().dismissNotification;
    var notifications = useAppSelector(function(param) {
        var collection = param.notifications;
        return collection;
    }).notifications;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: notifications.map(function(param, index) {
            var header = param.header, id = param.id, message = param.message, type = param.type;
            return /*#__PURE__*/ _jsx(Snackbar, {
                connotation: type,
                "data-testid": "snackbar-".concat(type),
                dismissible: true,
                header: header,
                icon: icons[type],
                index: index,
                message: message,
                onClose: function() {
                    return dismissNotification(id);
                },
                open: Boolean(id)
            }, id);
        })
    });
};

//# sourceMappingURL=NotificationsTicker.js.map